import {
  gql 
} from "@apollo/client"

export const DAILY_CHECK_IN = gql`
    mutation DailyCheckIn {
        dailyCheckIn {
            code
            message
            content
        }
    }
`

export const DAILY_SHARE_WEBSITE = gql`
    mutation DailyShareWebsite {
        dailyShareWebsite {
            code
            message
            content
        }
    }
`

export const FOLLOW_US_SOCIAL = gql`
    mutation FollowUsSocial($type: SocialEnum!) {
        followUsSocial(type: $type) {
            code
            message
            content
        }
    }
`

export const FACEBOOK_GROUP_BADGES = gql`
    mutation FacebookGroupBadges($type: FaceBookGroupBadgesEnum!) {
        facebookGroupBadges(type: $type) {
            code
            message
            content
        }
    }
`

export const FACEBOOK_GROUP_CONTRIBUTOR_VALUE = gql`
    mutation FacebookGroupContributorValue(
        $type: FaceBookGroupContributorValueEnum!
    ) {
        facebookGroupContributorValue(type: $type) {
            code
            message
            content
        }
    }
`

export const REDEEM_COUPON_CODE = gql`
    mutation RedeemCouponCode($points: Int!, $type: CouponCodeEnum) {
        redeemCouponCode(input: { type: $type, points: $points }) {
            code
            message
            content
        }
    }
`

export const REDEEM_ORDER_POINT = gql`
    mutation Redeem($ordernumber: String!, $platform: String!) {
        redeem(input: { ordernumber: $ordernumber, platform: $platform }) {
            code
            message
            content
        }
    }
`

export const GET_CUSTOMER_REWARDS_BALANCE = gql`
    query GetCustomerRewards {
        rewards {
            balance
        }
    }
`
